import axios from 'axios';
import store from '../store';
import { 
    APP_SET_SHOW_IMMEDIATELY, 
    APP_CHANGE_SELECTED_FISCAL_YEAR, 
    APP_SET_PARAMS_VALUES, 
    APP_SET_QUERY_VALUE, 
    REQUEST_GET_DISEASES_INJURIES, 
    REQUEST_GET_DISEASES_INJURIES_ERROR, 
    REQUEST_GET_DRUGS_TABLE, 
    REQUEST_GET_DRUGS_TABLE_ERROR, 
    REQUEST_GET_EXTERNAL_CAUSES, 
    REQUEST_GET_EXTERNAL_CAUSES_ERROR, 
    REQUEST_GET_METADATA, 
    REQUEST_GET_METADATA_ERROR, 
    REQUEST_GET_NEOPLASMS_TABLE, 
    REQUEST_GET_NEOPLASMS_TABLE_ERROR, 
    REQUEST_GET_TABULAR_DATA, 
    REQUEST_GET_TABULAR_DATA_ERROR, 
    REQUEST_INITIALIZE_GET_DISEASES_INJURIES, 
    REQUEST_INITIALIZE_GET_DRUGS_TABLE, 
    REQUEST_INITIALIZE_GET_EXTERNAL_CAUSES, 
    REQUEST_INITIALIZE_GET_NEOPLASMS_TABLE, 
    APP_SET_TABULAR_QUERY_VALUE,
    REQUEST_INITIALIZE_GET_TABULAR_DATA,
    APP_SET_SEARCH_TERM_VALUE,
    APP_SET_HISTORY,
    REQUEST_GET_APIVERSION,
    REQUEST_GET_APIVERSION_ERROR
} from './constants';

import { CURRENT_ENVIRONMENT } from '../config';

export function setParamsValues(query, fy) {
    store.dispatch({type: APP_SET_PARAMS_VALUES, payload: {query, fy}})
}

export function getMetadata() {
    return axios.get(`${CURRENT_ENVIRONMENT.apiUrl}/metadata`)
    .then((response) => {
        store.dispatch({ type: REQUEST_GET_METADATA, payload: response.data})
    })
    .catch((error) => {
        store.dispatch({ type: REQUEST_GET_METADATA_ERROR, payload: error })
    })
}

export function getApiVersion() {
    return axios.get(`${CURRENT_ENVIRONMENT.apiUrl}/version`)
    .then((response) => {
        store.dispatch({ type: REQUEST_GET_APIVERSION, payload: response.data})
    })
    .catch((error) => {
        store.dispatch({ type: REQUEST_GET_APIVERSION_ERROR, payload: error })
    })
}

export function updateQueryValue(query) {
    store.dispatch({type: APP_SET_QUERY_VALUE, payload: query });
}

export function updateHistory(query) {
    store.dispatch({type: APP_SET_HISTORY, payload: query });
}

export function updateTabularQueryValue(query, showImmediately = false) {
    store.dispatch({type: APP_SET_TABULAR_QUERY_VALUE, payload: query, showImmediately: showImmediately});
}

export function markShown() {
    store.dispatch({type: APP_SET_SHOW_IMMEDIATELY, payload: false });
}

export function queryIndexes(query, fy) {
    const trimmedQuery = query.trim().replace(/,/g, ' ').replace(/\s+/g, ' ');
    getDiseaseInjuries(trimmedQuery, fy);
    getExternalCauses(trimmedQuery, fy);
    getDrugsTable(trimmedQuery, fy);
    getNeoplasmsTable(trimmedQuery, fy);
    updateQueryValue(trimmedQuery);
    updateSearchTermValue(trimmedQuery);
    updateHistory(trimmedQuery);
}

export function updateSearchTermValue(query) {
    store.dispatch({type: APP_SET_SEARCH_TERM_VALUE, payload: query });
}

function clean_tabular_code(code) {
    var cleaned_code = code;
    // if square brackets around code, match only the code
    var bracket_regex = /^\[(.+)\]$/
    var bracket_match = bracket_regex.exec(code);
    if (bracket_match !== null) {
        cleaned_code = bracket_match[1]
    }
     // strip any trailing hyphen(s) and return
    return cleaned_code.replace(/-*$/, '')
}

export function queryTabularIndex(code, fy) {
    store.dispatch({ type: REQUEST_INITIALIZE_GET_TABULAR_DATA});
    const cleaned_code = clean_tabular_code(code);
    return axios.get(`${CURRENT_ENVIRONMENT.apiUrl}/${fy}/tabular/${cleaned_code}`)
    .then((response) => {
        store.dispatch({ type: REQUEST_GET_TABULAR_DATA, payload: { tabularData: response.data, tabularQuery: cleaned_code }})
    })
    .catch((error) => {
        store.dispatch({ type: REQUEST_GET_TABULAR_DATA_ERROR, payload: error })
    })
}

export function getInstructions(code, node, instructionType, fy) {
    return axios.get(`${CURRENT_ENVIRONMENT.apiUrl}/${fy}/tabular/instructions/${node}/${instructionType}/${code}`)
    .then((response) => {
        // Reformatting here since not using redux to handle state
        const data = response.data;
        const items = Object.keys(data).map((key) => {
            return {
                name: key,
                instructionItems: data[key].instruction_items
            }
        })
        return items;
    })
    .catch((error) => {
        console.error(error);
    })
}

export function getDiseaseInjuries(query, fy) {
    store.dispatch({ type: REQUEST_INITIALIZE_GET_DISEASES_INJURIES});
    return axios.get(`${CURRENT_ENVIRONMENT.apiUrl}/${fy}/index/diseases-injuries?query=${query}`)
    .then((response) => {
        store.dispatch({ type: REQUEST_GET_DISEASES_INJURIES, payload: response.data})
    })
    .catch((error) => {
        store.dispatch({ type: REQUEST_GET_DISEASES_INJURIES_ERROR, payload: error})
    })
}

export function getExternalCauses(query, fy) {
    store.dispatch({ type: REQUEST_INITIALIZE_GET_EXTERNAL_CAUSES});
    return axios.get(`${CURRENT_ENVIRONMENT.apiUrl}/${fy}/index/external-causes?query=${query}`)
    .then((response) => {
        store.dispatch({ type: REQUEST_GET_EXTERNAL_CAUSES, payload: response.data})
    })
    .catch((error) => {
        store.dispatch({ type: REQUEST_GET_EXTERNAL_CAUSES_ERROR, payload: error})
    })
}

export function getDrugsTable(query, fy) {
    store.dispatch({ type: REQUEST_INITIALIZE_GET_DRUGS_TABLE });
    return axios.get(`${CURRENT_ENVIRONMENT.apiUrl}/${fy}/index/drugs/table?query=${query}`)
    .then((response) => {
        store.dispatch({ type: REQUEST_GET_DRUGS_TABLE, payload: response.data})
    })
    .catch((error) => {
        store.dispatch({ type: REQUEST_GET_DRUGS_TABLE_ERROR, payload: error })
    })
}

export function getNeoplasmsTable(query, fy) {
    store.dispatch({ type: REQUEST_INITIALIZE_GET_NEOPLASMS_TABLE });
    return axios.get(`${CURRENT_ENVIRONMENT.apiUrl}/${fy}/index/neoplasms/table?query=${query}`)
    .then((response) => {
        store.dispatch({ type: REQUEST_GET_NEOPLASMS_TABLE, payload: response.data})
    })
    .catch((error) => {
        store.dispatch({ type: REQUEST_GET_NEOPLASMS_TABLE_ERROR, payload: error})
    })
}

export function changeSelectedFiscalYear(fiscalYear, query) {
    store.dispatch({type: APP_CHANGE_SELECTED_FISCAL_YEAR, payload: fiscalYear});
    if (query) {
        queryIndexes(query, fiscalYear);
    }
}
